/**
 * @fileoverview Back-compat entry for /metronome. The metronome now lives in
 * the segmented Tools screen; this renders it with the metronome tab active.
 */

import ToolsPage from "@/pages/ToolsPage";

const MetronomePage = () => <ToolsPage initialTab="metronome" />;

export default MetronomePage;
